import {Component, Input} from "@angular/core";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component(
  {
    selector: 'info-modal-promotion',
    template: `
      <div class="modal-header">
        <h4 class="modal-title">Promociones</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <img [src]="imgURL" class="form-control" id="upfile12" />
        <h5>{{dimensiones}}</h5>
      </div>
      <div class="modal-footer">
        <div>
          <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">Aceptar</button>
        </div>
      </div>
    `
  }
)
export class InfoModalComponent {
  @Input() imgURL: "";
  @Input() dimensiones: "";

  constructor(public activeModal: NgbActiveModal) {
  }

  /* disablePromotion() {
    this.loading = true;
    this.promocionesService.changePrincipal(this.promocion).subscribe(() => {
      this.promocion.defaultPromotion = !this.promocion.defaultPromotion;
      if (this.promocion.defaultPromotion) {
        this.promociones.forEach((promo) => {
          if (promo !== this.promocion) {
            promo.defaultPromotion = false;
          }
        });
      }
      this.activeModal.close();
    }, () => {
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  } */
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/info-modal.component.ts